import React, { createContext, useContext } from "react"

// Hooks
import { useToggle } from "../hooks"

export const AppState = createContext({
  navOpen: false,
  reverseHeader: false,
  headerPinned: false,
})

export const AppWrapper = ({ children }) => {
  const [navOpen, setNavOpen, toggleNavOpen] = useToggle(false)
  const [reverseHeader, setReverseHeader] = useToggle(false)
  const [headerPinned, setHeaderPinned] = useToggle(false)

  const closeNav = () => {
    setNavOpen(false)
  }

  return (
    <AppState.Provider
      value={{
        navOpen,
        reverseHeader,
        toggleNavOpen,
        closeNav,
        setNavOpen,
        setReverseHeader,
        headerPinned,
        setHeaderPinned,
      }}
    >
      {children}
    </AppState.Provider>
  )
}

export const useAppState = () => useContext(AppState)
